/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 06/08/2019 Modificado loadListaEntidad para añadir el tipo de llamada completa/minimo
 *  v 1.2 10/12/2019 Modificado el callbackOk de loadListaEntidad para enviar de parámetro response y no response.lo
 *  v 1.3 13/12/2019 Añadida función loadEntidad
 *  v.1.4 30/03/2020 Añadido parámetro callbackError en funcion loadListaEntidad.
 *  v.1.5 11/05/2020 Añadida función loadServicioEntidad
 *  v.1.6 29/09/2022 Modificada la función loadServicioEntidad, para solo lanzar el callbackOk si es exitoso.
 *  v.1.7 06/03/2023 Añadida función loadServicioMinimoEntidad
 *  v.1.8 31/07/2023 Modificada la función loadServicioEntidad, para el caso en el que no hay nombreClase.
 **/

import {
    servicioRestful,
    servidor,
    servicioRestfulCompleto,
    servicioRestfulMinimo
} from "../../../dental/Configuracion";
import ClienteRestful from "../network/ClienteRestful";

export const loadListaEntidad= (tipo, nombreClase, filtro, callbackOk, callbackError) => {
    let url= servidor + tipo + "/" + servicioRestful + "list/" + nombreClase;
    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(filtro, response => {callbackOk && callbackOk(response);},
        response => {callbackError && callbackError(response)});
}

export const loadEntidad= (nombreClase, codigo, callbackOk) => {
    //console.log("Load Entidad");
    let url= servidor + "completo/" + servicioRestful + nombreClase + "/" + codigo;
    //console.log("url: ", url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doGet(response => {
        //console.log("response: ", response);
        callbackOk && callbackOk(response);
    }, response => {
        console.log("Error: ");
        console.log("response: ", response);
    });
}

export const loadServicioEntidad= (nombreClase, servicio, parametros, callbackOk, callbackError) => {
    let url= servidor + servicioRestfulCompleto + "servicio/" + nombreClase + "/" + servicio;
    if (nombreClase == null) //Esperamos que en el servicio venga Clase/Servicio
        url= servidor + servicioRestfulCompleto + "servicio/" +  servicio;

    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(parametros, response => {
        //console.log("loadServicioEntidad: ", servicio);
        if (clienteRestful.isExito()) {
           //console.log("Exito: ", response);
           callbackOk && callbackOk(response);
        }
        else
            callbackError && callbackError(response);
        },
        response => {callbackError && callbackError(response)});
}

export const loadServicioMinimoEntidad= (nombreClase, servicio, parametros, callbackOk, callbackError) => {
    let url= servidor + servicioRestfulMinimo + "servicio/" + nombreClase + "/" + servicio;
    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(parametros, response => {
            if (clienteRestful.isExito())
                callbackOk && callbackOk(response);
            else {
                callbackError && callbackError(response);
            }
        },
        response => {
            callbackError && callbackError(response)
        }
    );
}

export const loadServicioActuadorMinimoEntidad= (nombreClase, servicio, parametros, callbackOk, callbackError) => {
    let url= servidor + servicioRestfulMinimo + "servicioactuador/" + nombreClase + "/" + servicio;
    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(parametros, response => {
            if (clienteRestful.isExito())
                callbackOk && callbackOk(response);
            else {
                callbackError && callbackError(response);
            }
        },
        response => {
            callbackError && callbackError(response)
        }
    );
}

